import styled from 'styled-components'
import { Modal } from 'reactstrap'

// Bootstrap modal-lg is 800px; 30% wider = 1040px (65rem)
// className from styled(Modal) is applied to .modal-dialog, not a parent wrapper
export const SitePreferencesModalContainer = styled(Modal)`
  &.modal-dialog {
    max-width: 65rem;
    width: 90%;
  }
`
